/**
 * 401 을 한 곳에서 처리한다.
 *
 * 🔴 왜 axios 기본 인스턴스에 거는가:
 *    이 리포의 `src/api/*.ts` 는 전부 `axios.get(...)` 처럼 **기본 인스턴스를 직접** 쓴다.
 *    이 리포에는 공유 axios 인스턴스 자체가 없고, `interceptors`·`401` 이 전 소스에 0건이었다.
 *    공유 인스턴스로 옮기는 것이 최종 모습이지만, 그 전에 **401 이 먼저 필요하다** —
 *    토큰이 무효가 되면 지금은 화면이 조용히 빈 채로 남고 관리자는 다시 로그인할 방법을 모른다.
 *    기본 인스턴스에 한 번 걸면 **기존 호출 전부가 덮인다.**
 *
 * ⚠️ 본사 콘솔(`zerosalon-admin-front`)에 같은 파일이 있다. 한쪽을 고치면 다른 쪽도 고친다.
 */
import axios, { AxiosError, AxiosResponse } from 'axios';

const SIGN_IN = '/authentication/sign-in';

// 🔴 병렬 요청 여러 개가 동시에 401 을 받으면 리다이렉트가 그 수만큼 겹친다.
//    한 번만 처리하고, 이동하면 페이지가 새로 뜨므로 되돌릴 필요가 없다.
let handled = false;

export function handleUnauthorized(): void {
  if (handled) return;
  handled = true;

  try {
    localStorage.removeItem('user');
  } catch (e) {
    // 사파리 프라이빗 모드 등에서 던질 수 있다. 이동은 그래도 해야 한다.
  }

  if (window.location.pathname !== SIGN_IN) {
    // href 가 아니라 replace 다 — 뒤로가기로 깨진 화면에 돌아오지 않게 한다.
    window.location.replace(SIGN_IN);
  }
}

export default function installAuthInterceptor(): void {
  axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    // 🔴 `error` 를 any 로 두면 eslint 의 no-unsafe-member-access 로 빌드가 막힌다.
    (error: AxiosError) => {
      if (error.response?.status === 401) handleUnauthorized();
      return Promise.reject(error);
    }
  );
}
